import { 
    SET_LOADING,
    SET_PROJECT_CATEGORY_LIST,
} from "../../actions/projectCategory/types";

const INITIAL_STATE = {
    loading: false,
    projectCategoryList: [],
}

const ProjectCategoryReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_PROJECT_CATEGORY_LIST: {
            return {
                ...state,
                projectCategoryList : action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default ProjectCategoryReducer;